import {connect} from "react-redux"
import {createSelector} from "reselect"
import {AggregatorColourwayBundlesApiContract} from "../../../../models/searchApi/bundle"
import State from "../../../../models/state"
import {fetchAdditionalColourchipsThunk, setAdditionalColourchipsLoading} from "../../../../ducks/productSummary"
import {ColourwayData} from "../../../../models/searchApi"
import {SofaColourwayData} from "../../../../models/searchApi/sofa"
import {getColourChipUrl} from "../../../../utils/getImageUrls"
import {formatPdpLink, formatTitle} from "../../../../utils/colourwayBuilders"
import {selectPriceType} from "../../../../utils/priceFormatter/selectPriceType"
import {BundleType} from "../../../../config/constants"

const selectColourways = (state: State) => state.productSummary.summaryData.colourways
const selectType = (state: State) => state.productSummary.summaryData.type
const selectImageCdnUrl = (state: State) => state.productSummary.summaryData.imageCdnUrl
const selectBaseUrl = (state: State) => state.productSummary.summaryData.baseUrl
const selectTitle = (state: State) => state.productSummary.summaryData.title
const selectCurrencyCode = (state: State) => state.productSummary.summaryData.currencyCode
const selectDepartment = (state: State) => state.productSummary.summaryData.department
const selectFit = (state: State) => state.productSummary.summaryData.fit
const selectIsEnglishLang = (state: State) => state.request.isEnglishLang

const colourchipsSelector = createSelector(
    [
        selectColourways,
        selectType,
        selectImageCdnUrl,
        selectBaseUrl,
        selectTitle,
        selectCurrencyCode,
        selectDepartment,
        selectFit,
        selectIsEnglishLang,
    ],
    (colourways, type, imageCdnUrl, baseUrl, defaultTitle, currencyCode, department, fit, isEnglishLang) =>
        (colourways as ColourwayData[]).map(colourway => ({
            itemNumber: colourway.id,
            colourChipUrl: getColourChipUrl({
                type,
                id:
                    type === BundleType
                        ? (colourway as unknown as AggregatorColourwayBundlesApiContract).associatedColourway
                              ?.itemNumber
                        : colourway.id,
                imageCdnUrl,
                colourChipImage: (colourway as SofaColourwayData)?.cci,
            }),
            linkUrl: formatPdpLink(baseUrl, colourway.url),
            isSelected: colourway.s,
            colour: colourway.c,
            title: colourway.t ?? `${colourway.c} ${defaultTitle}`,
            price: selectPriceType(colourway.p, colourway?.sp),
            currencyCode,
            department,
            altText: formatTitle({
                title: defaultTitle,
                department,
                fit,
                selectedColourway: colourway,
                isEnglishLang,
            }),
        })),
)

export const mapStateToProps = (state: State) => {
    const {
        productSummary: {numberOfAllColourways, additionalColourchipsLoading, mobileThumbnailConfig},
        lazyload: {colourchips},
        template,
        textAlignment,
    } = state

    return {
        template,
        lazyloadColourchips: colourchips,
        numberOfAllColourways,
        additionalColourchipsLoading,
        colourchips: colourchipsSelector(state),
        mobileThumbnailConfig,
        textAlignment,
    }
}

const mapDispatchToProps = {
    fetchAdditionalColourchipsThunk,
    setAdditionalColourchipsLoading,
}

export default connect(mapStateToProps, mapDispatchToProps)
